// extracted by mini-css-extract-plugin
export default {"root":"ttRbgfOPacx5QJlMiIOH","row":"VFrq5Z8FahYwJek48oJQ"};